/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './NoiseAlwaysConnectedSlider.scss';
import leftArrow from '../../../../assets/smartxonnect/left.webp';
import rightArrow from '../../../../assets/smartxonnect/right.webp';
import whiteLeftArrow from '../../../../assets/smartxonnect/white-left-arrow.webp';
import whiteRightArrow from '../../../../assets/smartxonnect/white-left-arrow.webp';
import ChargingStatus from '../../../../assets/noise/charging-status02.webp';
import RideStats from '../../../../assets/noise/ride-stats.webp';
import LowChargeAlert from '../../../../assets/noise/low-charge-alert.webp';
import NoiseHealth from '../../../../assets/noise/noise-health.webp';
import CarbonSaved from '../../../../assets/noise/carbon-saved.webp';
import IconPlus from '../../../../assets/noise/downarrow.png';
import IconMinus from '../../../../assets/noise/downarrow.png';
// const PrevArrow = (props) => {
//   const { className, onClick, isDisabled } = props;

//   const handlePrevClick = () => {
//     if (!isDisabled) {
//       dataLayer.push({
//         event: 'always_connected_banner_navigation',
//         action: 'previous_arrow_clicked',
//         BrandName: 'TVS iQube',
//         VariantName: 'SmartXonnect',
//       });
//       onClick();
//     }
//   };

//   return (
//     <div className={`${className} custom-prev-arrow`} onClick={handlePrevClick}>
//       <img src={isDisabled ? whiteLeftArrow : leftArrow} alt="Previous" loading="lazy" />
//     </div>
//   );
// };

// const NextArrow = (props) => {
//   const { className, onClick, isDisabled } = props;

//   const handleNextClick = () => {
//     if (!isDisabled) {
//       dataLayer.push({
//         event: 'always_connected_banner_navigation',
//         action: 'next_arrow_clicked',
//         BrandName: 'TVS iQube',
//         VariantName: 'SmartXonnect',
//       });
//       onClick();
//     }
//   };

//   return (
//     <div className={`${className} custom-next-arrow`} onClick={handleNextClick}>
//       <img
//         src={isDisabled ? whiteLeftArrow : rightArrow}
//         alt="Next"
//         className={isDisabled ? 'disabled' : 'rotate-180'}
//         loading="lazy"
//       />
//     </div>
//   );
// };
const AccordionItem = ({ item, isOpen, onToggle }) => {
  return (
    <div className={`noiseaccordion-item ${isOpen ? 'open' : ''}`}>
      <div className="noiseaccordion-header gotham-medium" onClick={onToggle}>
        <h3 className="gotham-medium">{item.title}</h3>
        <img
          src={isOpen ? IconMinus : IconPlus}
          alt={isOpen ? 'Collapse' : 'Expand'}
          className="accordion-toggle-icon"
        />
      </div>
      {isOpen && (
        <div className="noiseaccordion-body gotham-medium">
          <div className="noiseaccordion-image">
            <img src={item.image} alt={item.title} loading="lazy" />
          </div>
          <p className="gotham-medium">{item.description}</p>
        </div>
      )}
    </div>
  );
};
const NoiseAlwaysConnectedSlider = (props) => {
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const data = [
    {
      title: 'Charging Status (Time to Charge)',
      description: 'Know your scooter’s charging status anytime right from your wrist',
      image: ChargingStatus,
    },
    {
      title: 'Ride Statistics ',
      description: 'Stay informed with key ride metrics before, during and after every journey',
      image: RideStats,
    },
    {
      title: 'Low Charge and Charge Completion Alerts',
      description: 'Know right away when it’s time to plug in or unplug your scooter',
      image: LowChargeAlert,
    },
    {
      title: 'Noise Health Suite',
      description: 'Stay on top of your health with real-time wellness insights on your wrist',
      image: NoiseHealth,
    },
    {
      title: 'Carbon Saved',
      description: 'See how much carbon you save with every ride right on your watch.',
      image: CarbonSaved,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  return (
    <div
      className="noise-always-connected-slider-wrapper always commonContainer "
      data-aos="fade-up"
      ref={sliderRef}
    >
      <div className="header-section">
        <h2 className="before-ride-header gotham-medium">{props?.fields?.Heading?.value}</h2>
        <h4 className="subtitle gotham-medium">{props?.fields?.Title?.value}</h4>
      </div>
      <div className="slider-section">
        {isMobile ? (
          <div className="accordion-mobile-view">
            {data.map((item, index) => (
              <AccordionItem
                key={index}
                item={item}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? null : index)}
              />
            ))}
          </div>
        ) : (
          <Slider {...settings}>
            {data.map((item, index) => (
              <div key={index} className="always-connected-slider-card">
                <div className="always-connected-slider-image">
                  <img src={item.image} alt={item.title} loading="lazy" />
                </div>
                <div className="always-connected-slider-content">
                  <h2 className="gotham-medium always-connected-title">{item.title}</h2>
                  <p className="gotham-medium always-connected-subtitle">{item.description}</p>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default React.memo(NoiseAlwaysConnectedSlider);
